import { Datatype } from '../../../../datatype/Datatype.ts';
import { createConditionOperator } from '../../IConditionOperator.ts';

export const ConditionOperatorCaseInsensitiveEqualsType =
  createConditionOperator({
    code: 'equalsCaseInsensitive',
    label: 'uguale (case insensitive)',
    description: 'Uguale a (case insensitive)',
    args: [{ type: 'referenceValue' }],
    allowsField: field => field.type === Datatype.String,
    compare(value: any, [target]: [any]) {
      if (value == null && target == null) return true;
      if (value == null || target == null) return false;

      return String(value).toLowerCase() === String(target).toLowerCase();
    },
  });
